<template>
  <div class="view">
    <h1 class="font--bigger m-t-0 c-black">
      <span>{{ $t('Publish Articles for Widget') }}</span>
    </h1>

    <!-- Filter -->
    <FormFilterArticles @submit="requestArticles" @change-widget="onChangeWidget" />

    <!-- Table -->
    <el-card>
      <TableArticles
        :data="articles"
        :auto-publication="widgetIsAutoPublication"
        @publish="publishArticle"
        @unpublish="unPublishArticle"
        v-loading="isLoadingArticles || isLoadingWidgets"
      />
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FormFilterArticles from '@/components/Form/FormFilterArticles';
import TableArticles from '@/components/Table/BB_TableArticles';
import { MODULE_NAME as ARTICLES_MODULE } from '@/store/modules/bb_articles';
import { MODULE_NAME as WIDGETS_MODULE } from '@/store/modules/bb_widgets';
import { get, uniqBy } from 'lodash';

export default {
  name: 'AllArticles',

  components: {
    FormFilterArticles,
    TableArticles
  },

  computed: {
    ...mapGetters({
      allArticles: `${ARTICLES_MODULE}/all`,
      isLoadingArticles: `${ARTICLES_MODULE}/isLoading`,
      isLoadingWidgets: `${WIDGETS_MODULE}/isLoading`,
      widgets: `${WIDGETS_MODULE}/all`
    }),

    articles() {
      const articles = [...this.widgetArticles, ...this.allArticles];
      return uniqBy(articles, 'id');
    },

    widgetArticles() {
      const result = [];

      if (!this.widgetIsAutoPublication) {
        const articles = get(this.selectedWidget, 'articles');
        if (articles) {
          articles.forEach(articleItem => {
            const article = get(articleItem, 'article');
            if (article) {
              // Set boolean to indicate that the article has been manually published
              article.isManuallyPublished = true;
              result.push(article);
            }
          });
        }
      }

      return result;
    },

    widgetIsAutoPublication() {
      return this.selectedWidget.auto_publication;
    }
  },

  data() {
    return {
      selectedWidget: {
        auto_publication: true
      }
    };
  },

  methods: {
    onChangeWidget(item) {
      this.selectedWidget = item;
    },

    async publishArticle(item) {
      const obj = {
        article: { id: item.id }
      };

      const PAYLOAD = {
        id: this.selectedWidget.id,
        articles: [obj]
      };

      const response = await this.$store.dispatch('bb_widgets/UPDATE_WIDGET', PAYLOAD);
      const data = get(response, 'data');
      if (data) {
        // Update current widget to get published articles
        this.$store.dispatch(`${WIDGETS_MODULE}/GET_WIDGET_BY_ID`, { id: this.selectedWidget.id });
      }
    },

    async unPublishArticle(item) {
      const widgetArticles = get(this.selectedWidget, 'articles', []);
      const widgetArticle = widgetArticles.find(wArticle => wArticle.article.id === item.id);
      let deleteObj = null;
      if (widgetArticle && widgetArticle.hasOwnProperty('id')) {
        deleteObj = {
          id: widgetArticle.id,
          $delete: true
        };
      }

      if (!deleteObj) {
        throw new Error('No article found to unpublish');
      }

      const PAYLOAD = {
        id: this.selectedWidget.id,
        articles: [deleteObj]
      };

      const response = await this.$store.dispatch('bb_widgets/UPDATE_WIDGET', PAYLOAD);
      const data = get(response, 'data');
      if (data) {
        // Update current widget to get published articles
        this.$store.dispatch(`${WIDGETS_MODULE}/GET_WIDGET_BY_ID`, { id: this.selectedWidget.id });
      }
    },

    requestArticles() {
      this.$store.dispatch(`${ARTICLES_MODULE}/GET_ARTICLES`);
    }
  }
};
</script>
